import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button, Input, Select } from "@/components/Kit";
import { CURRENCIES } from "@/lib/format";
import { Wallet } from "@phosphor-icons/react";

const BG = "https://images.unsplash.com/photo-1579548122080-c35fd6820ecb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGRhcmslMjBncmFkaWVudCUyMGdlb21ldHJpYyUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg0Njg2Mjg3fDA&ixlib=rb-4.1.0&q=85";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", baseCurrency: "USD" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-obsidian/60" />
        <div className="relative h-full flex flex-col justify-between p-12">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-md bg-cyan flex items-center justify-center">
              <Wallet size={20} weight="fill" className="text-black" />
            </div>
            <span className="font-heading font-extrabold text-xl tracking-tighter">Ledgerly</span>
          </div>
          <div>
            <h2 className="font-heading font-extrabold text-4xl tracking-tighter leading-none max-w-sm">
              Your financial clarity starts here.
            </h2>
            <p className="text-[#A1A1AA] mt-4 max-w-sm">
              One dashboard for transactions, budgets and insights — in any currency.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-sm animate-fade-up">
          <h1 className="font-heading font-extrabold text-3xl tracking-tighter mb-2">Create account</h1>
          <p className="text-[#A1A1AA] text-sm mb-8">Start managing your money in minutes.</p>
          <form onSubmit={submit} className="space-y-4">
            <Input label="Full name" value={form.name} onChange={set("name")} placeholder="Jane Doe" required data-testid="register-name" />
            <Input label="Email" type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" required data-testid="register-email" />
            <Input label="Password" type="password" value={form.password} onChange={set("password")} placeholder="At least 6 characters" required data-testid="register-password" />
            <Select label="Base currency" value={form.baseCurrency} onChange={set("baseCurrency")} data-testid="register-currency">
              {CURRENCIES.map((c) => <option key={c} value={c}>{c}</option>)}
            </Select>
            <Button type="submit" disabled={loading} className="w-full" data-testid="register-submit-btn">
              {loading ? "Creating..." : "Create account"}
            </Button>
          </form>
          <p className="text-sm text-[#A1A1AA] mt-6">
            Already have an account?{" "}
            <Link to="/login" className="text-cyan hover:underline" data-testid="go-login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
